import React, { useState } from 'react';
import Button from './Button';
import Select from './Select';
import Icon from '../AppIcon';

const ExportReportGenerator = ({ className = "" }) => {
  const [selectedFormat, setSelectedFormat] = useState('pdf');
  const [selectedDateRange, setSelectedDateRange] = useState('last-30-days');
  const [selectedReportType, setSelectedReportType] = useState('comprehensive');
  const [isGenerating, setIsGenerating] = useState(false);

  const formatOptions = [
    { value: 'pdf', label: 'PDF Document' },
    { value: 'excel', label: 'Excel Spreadsheet' },
    { value: 'csv', label: 'CSV Data' },
    { value: 'json', label: 'JSON Export' }
  ];

  const dateRangeOptions = [
    { value: 'last-7-days', label: 'Last 7 Days' },
    { value: 'last-30-days', label: 'Last 30 Days' },
    { value: 'last-90-days', label: 'Last 90 Days' },
    { value: 'custom', label: 'Custom Range' }
  ];

  const reportTypeOptions = [
    { value: 'comprehensive', label: 'Comprehensive Report' },
    { value: 'summary', label: 'Executive Summary' },
    { value: 'property-specific', label: 'Property Specific' },
    { value: 'client-specific', label: 'Client Specific' },
    { value: 'financial', label: 'Financial Analysis' }
  ];

  const handleGenerateReport = async () => {
    setIsGenerating(true);
    
    // Simulate report generation
    setTimeout(() => {
      setIsGenerating(false);
      // In real implementation, this would trigger download
      // Report generated with format, dateRange, and reportType
    }, 2000);
  };

  const handleQuickExport = (format) => {
    setSelectedFormat(format);
    handleGenerateReport();
  };

  return (
    <div className={`bg-card rounded-lg border border-border p-6 ${className}`}>
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center space-x-2">
          <Icon name="Download" size={20} color="var(--color-primary)" />
          <h3 className="text-lg font-semibold text-foreground">Export & Reports</h3>
        </div>
        
        {/* Quick Export Buttons */}
        <div className="hidden lg:flex items-center space-x-2">
          <Button
            variant="ghost"
            size="sm"
            onClick={() => handleQuickExport('pdf')}
            iconName="FileText"
            iconPosition="left"
            title="Quick PDF export"
          >
            PDF
          </Button>
          <Button
            variant="ghost"
            size="sm"
            onClick={() => handleQuickExport('excel')}
            iconName="Sheet"
            iconPosition="left"
            title="Quick Excel export"
          >
            Excel
          </Button>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
        <Select
          label="Report Type"
          options={reportTypeOptions}
          value={selectedReportType}
          onChange={setSelectedReportType}
          className="w-full"
        />
        
        <Select
          label="Date Range"
          options={dateRangeOptions}
          value={selectedDateRange}
          onChange={setSelectedDateRange}
          className="w-full"
        />
        
        <Select
          label="Export Format"
          options={formatOptions}
          value={selectedFormat}
          onChange={setSelectedFormat}
          className="w-full"
        />
      </div>

      <div className="flex flex-col sm:flex-row gap-3">
        <Button
          variant="default"
          onClick={handleGenerateReport}
          loading={isGenerating}
          iconName="Download"
          iconPosition="left"
          className="flex-1"
        >
          {isGenerating ? 'Generating Report...' : 'Generate Report'}
        </Button>
        
        <Button
          variant="outline"
          onClick={() => {
            // Schedule report functionality
            {/* Schedule report action */}
          }}
          iconName="Calendar"
          iconPosition="left"
        >
          Schedule
        </Button>
        
        <Button
          variant="ghost"
          onClick={() => {
            // View previous reports
            {/* View previous reports action */}
          }}
          iconName="History"
          iconPosition="left"
        >
          History
        </Button>
      </div>

      {/* Report Preview Info */}
      <div className="mt-4 p-3 bg-muted rounded-md">
        <div className="flex items-start space-x-2">
          <Icon name="Info" size={16} color="var(--color-muted-foreground)" className="mt-0.5" />
          <div className="text-sm text-muted-foreground">
            <p className="font-medium mb-1">Report will include:</p>
            <ul className="text-xs space-y-1">
              <li>• Property valuations and survey data</li>
              <li>• Client interaction summaries</li>
              <li>• Performance metrics and analytics</li>
              <li>• Compliance and audit information</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExportReportGenerator;